'use strict';
/**
 * @author Maxim Seredkin
 */

import { Operator } from '../../operator/enum/operator';

export default ['$uibModal', 'SupportRestService',
    function ($modal, SupportRestService) {

        const rangeType = {
            INVESTMENT: 'INVESTMENT',
            WORK_PLACES: 'WORK_PLACES',
            ENCLOSURE: 'ENCLOSURE',
            FACILITIES: 'FACILITIES',
            PERIOD: 'PERIOD',
        }

        return {
            select: select,
            edit: edit,
            create: create,
            filter: filter,
            defaultSupport: defaultSupport,
            rangeType: rangeType,
            convertDTO: convertDTO,
            convertToDTO: convertToDTO,
            api: SupportRestService
        };

        function defaultSupport() {
            return {
                name: null,
                supportType: null,

                okved: [],
                industry: [],
                area: [],
                operation: [],

                investmentSizeOperator: Operator.BETWEEN,
                investmentSize1: null,
                investmentSize2: null,

                workplacesOperator: Operator.BETWEEN,
                workplaces1: null,
                workplaces2: null,

                capitalInvestmentOperator: Operator.BETWEEN,
                capitalInvestment1: null,
                capitalInvestment2: null,

                personalInvestmentOperator: Operator.BETWEEN,
                personalInvestment1: null,
                personalInvestment2: null,

                yearOperator: Operator.BETWEEN,
                year1: null,
                year2: null,

                scale: null,
                requirements: null,
                application: null,
                contacts: null,
                status: null,
                attachment: null,
                description: null,
                shortDescription: null,
            }
        }

        function convertDTO(items, parent) {
            const constructOperator = (range) => {
                if (range.from !== null) {
                    if (range.to !== null) {
                        return Operator.BETWEEN;
                    }
                    return Operator.GE
                } else if (range.to !== null) {
                    return Operator.LE;
                }
                return Operator.BETWEEN;
            } 
            return items.map(item => {
                const support = { ...defaultSupport(), ...item };
                if (item.areaIds != null && item.areaIds.length) {
                    support.area = item.areaIds.split(',').map(n => parent.areasesObject[n]).filter(Boolean);
                }
                if (item.industryIds != null && item.industryIds.length) {
                    support.industry = item.industryIds.split(',').map(n => parent.industriesObject[n]).filter(Boolean);
                }
                if (item.okvedIds != null && item.okvedIds.length) {
                    support.okved = item.okvedIds.split(',').map(n => parent.okvedsObject[n]).filter(Boolean);
                }
                if (item.operationIds != null && item.operationIds.length) {
                    support.operation = item.operationIds.split(',').map(n => parent.operationsObject[n]).filter(Boolean);
                }

                item.ranges.forEach((range) => {
                    if (range.type === rangeType.WORK_PLACES) {
                        support.workplacesOperator = constructOperator(range);
                        support.workplaces1 = range.from !== null ? range.from : range.to;
                        support.workplaces2 = [Operator.BETWEEN].includes(support.workplacesOperator) ? range.to : null;
                    } else if (range.type === rangeType.PERIOD) {
                        support.yearOperator = constructOperator(range);
                        support.year1 = range.from !== null ? range.from : range.to;
                        support.year2 = [Operator.BETWEEN].includes( support.yearOperator) ? range.to : null;
                    } else if (range.type === rangeType.INVESTMENT) {
                        support.investmentSizeOperator = constructOperator(range);
                        support.investmentSize1 = range.from !== null ? range.from : range.to;
                        support.investmentSize2 = [Operator.BETWEEN].includes(support.investmentSizeOperator) ? range.to : null;
                    } else if (range.type ===rangeType.FACILITIES) {
                        support.capitalInvestmentOperator = constructOperator(range);
                        support.capitalInvestment1 = range.from !== null ? range.from : range.to;
                        support.capitalInvestment2 = [Operator.BETWEEN].includes(support.capitalInvestmentOperator) ? range.to : null;
                    } else if (range.type === rangeType.ENCLOSURE) {
                        support.personalInvestmentOperator = constructOperator(range);
                        support.personalInvestment1 = range.from !== null ? range.from : range.to;
                        support.personalInvestment2 = [Operator.BETWEEN].includes(support.personalInvestmentOperator) ? range.to : null;
                    }
                });
                return support;
            })
        }

        function convertToDTO(item) {
            const parseOperator = (type, operator, field1, field2) => {
                if (field1 === null && field2 === null) return null;
                return {
                    from: ['GE', 'BETWEEN'].includes(operator) ? field1 : null,
                    to: operator === Operator.LE ? field1 : operator === Operator.BETWEEN ? field2 : null,
                    type: type
                }
            }

            return {
                id: item.id,
                name: item.name,
                supportType: item.supportType,
                okvedIds: item.okved.length ? item.okved.map(n => n.id).toString() : null,
                industryIds: item.industry.length ? item.industry.map(n => n.id).toString() : null,
                areaIds: item.area.length ? item.area.map(n => n.id).toString() : null,
                operationIds: item.operation.length ? item.operation.map(n => n.id).toString() : null,
                ranges: [
                    parseOperator(rangeType.INVESTMENT, item.investmentSizeOperator, item.investmentSize1, item.investmentSize2),
                    parseOperator(rangeType.WORK_PLACES, item.workplacesOperator, item.workplaces1, item.workplaces2),
                    parseOperator(rangeType.PERIOD, item.yearOperator, item.year1, item.year2),
                    parseOperator(rangeType.FACILITIES, item.capitalInvestmentOperator, item.capitalInvestment1, item.capitalInvestment2),
                    parseOperator(rangeType.ENCLOSURE, item.personalInvestmentOperator, item.personalInvestment1, item.personalInvestment2),
                ].filter(n => n),
                scale: item.scale,
                requirements: item.requirements,
                application: item.application,
                contacts: item.contacts,
                status: item.status,
                attachment: item.attachment,
                description: item.description,
                shortDescription: item.shortDescription,
            }
        }

        function select(support, types, okveds, areas, operators, industries, operations) {
            return $modal.open({
                template: require('../view/support-modal-select.html'),
                controller: 'SupportModalSelectController',
                controllerAs: 'vm',
                size: 'w1200',
                backdrop: false,
                resolve: {
                    support: function () {
                        return support != null ? support : defaultSupport();
                    },
                    types: function () {
                        return types;
                    },
                    okveds: function () {
                        return okveds;
                    },
                    areases: function () {
                        return areas;
                    },
                    operators: function () {
                        return operators;
                    },
                    industries: function () {
                        return industries;
                    },
                    operations: function () {
                        return operations;
                    },
                }
            });
        }

        function create(types, okveds, areas, operators, industries, operations) {
            return $modal.open({
                template: require('../view/support-modal-create.html'),
                controller: 'SupportModalCreateController',
                controllerAs: 'vm',
                size: 'w1200',
                backdrop: false,
                resolve: {
                    support: function () {
                        return defaultSupport();
                    },
                    types: function () {
                        return types;
                    },
                    okveds: function () {
                        return okveds;
                    },
                    areases: function () {
                        return areas;
                    },
                    operators: function () {
                        return operators;
                    },
                    industries: function () {
                        return industries;
                    },
                    operations: function () {
                        return operations;
                    },
                }
            });
        }

        function edit(item, types, okveds, areas, operators, industries, operations) {
            return $modal.open({
                template: require('../view/support-modal-select.html'),
                controller: 'SupportModalSelectController',
                controllerAs: 'vm',
                size: 'w1200',
                backdrop: false,
                resolve: {
                    support: function () {
                        return item;
                    },
                    types: function () {
                        return types;
                    },
                    okveds: function () {
                        return okveds;
                    },
                    areases: function () {
                        return areas;
                    },
                    operators: function () {
                        return operators;
                    },
                    industries: function () {
                        return industries;
                    },
                    operations: function () {
                        return operations;
                    },
                }
            });
        }

        function filter(types, okveds, areas, operators, industries) {
            return $modal.open({
                template: require('../view/support-filter.html'),
                controller: 'SupportFilterController',
                controllerAs: 'vm',
                size: 'w500',
                backdrop: false,
                resolve: {
                    types: function () {
                        return types;
                    },
                    okveds: function () {
                        return okveds;
                    },
                    areases: function () {
                        return areas;
                    },
                    operators: function () {
                        return operators;
                    },
                    industries: function () {
                        return industries;
                    },
                }
            });
        }

    }];